import type { User } from 'src/store/user';
import type { SignInPayload } from 'src/pages/auth/SignIn/schema';
import type { CreateProcurerPayload } from 'src/pages/auth/Create/Procurer/schema';

import { axios, formatError } from './utils';

interface SignInApiResponse {
  token: string;
  user: User;
  redirectToPath?: string;
}

const USERS_BASE = '/api/users';

export async function signIn(data: SignInPayload): Promise<SignInApiResponse> {
  try {
    const response = await axios.post(`${USERS_BASE}/sign-in`, data);
    return response.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export const getLoggedInUserInfo = async (): Promise<User> => {
  try {
    const { data } = await axios.get<User>(`${USERS_BASE}/my-info`);
    return data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
};

interface CreateProcurerApiResponse {
  user: User;
}

export const createProcurerAccount = async (
  data: CreateProcurerPayload
): Promise<CreateProcurerApiResponse> => {
  try {
    const response = await axios.post(`${USERS_BASE}/create-procurer`, data);
    return response.data;
  } catch (error) {
    throw formatError(error);
  }
};

export const signOut = async () => {
  await axios.post(`${USERS_BASE}/sign-out`);
};

export interface ForgotPasswordPayload {
  email: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export const forgotPassword = async (
  data: ForgotPasswordPayload
): Promise<ForgotPasswordResponse> => {
  try {
    const response = await axios.post(`${USERS_BASE}/reset-password`, data);
    return response.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
};

export interface ValidateResetTokenResponse {
  valid: boolean;
  message: string;
}

export const validateResetToken = async (token: string): Promise<ValidateResetTokenResponse> => {
  try {
    const response = await axios.get(`${USERS_BASE}/validate-reset-token`, {
      params: { token },
    });
    return response.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
};

export interface ChangePasswordApiPayload {
  token: string;
  password: string;
}

export interface ChangePasswordResponse {
  message: string;
}

export const changePassword = async (
  data: ChangePasswordApiPayload
): Promise<ChangePasswordResponse> => {
  try {
    const response = await axios.post(`${USERS_BASE}/change-password`, data);
    return response.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
};
